import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTranslationDir } from '../../hooks/useTranslationDir';

export const MethodTotalsCard = ({ methodTotals }) => {
  const { t, i18n } = useTranslation();
  const { isRTL } = useTranslationDir();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat(i18n.language === 'ar' ? 'ar' : 'en-US', {
      style: 'currency',
      currency: 'EGP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6 mb-6">
      <h3 className="text-lg font-semibold text-slate-900 mb-4">
        {t('transactions.paymentMethodTotals')}
      </h3>
      <div className="space-y-4">
        {methodTotals && Object.entries(methodTotals).map(([methodName, method], key) => (
          <div key={key} className="border-b border-slate-100 pb-4 last:border-0 last:pb-0">
            <div className="flex items-center justify-between mb-2">
              <span className="font-medium text-slate-900">{t(methodName)}</span>
              <span className={`font-semibold ${method.net >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                {formatCurrency(method.net)}
              </span>
            </div>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="text-slate-600">{t('transactions.income')}: </span>
                <span className="text-green-600 font-medium">
                  {formatCurrency(method.income)} ({method.incomeCount})
                </span>
              </div>
              <div>
                <span className="text-slate-600">{t('transactions.outcome')}: </span>
                <span className="text-red-600 font-medium">
                  {formatCurrency(method.outcome)} ({method.outcomeCount})
                </span>
              </div>
            </div>
            <div className="text-xs text-slate-500 mt-1">
              {method.count} {t('transactions.transactions')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
